module.exports = __webpack_public_path__ + "static/media/trophy.d554d5ac.svg";